import classNames from 'classnames';
import './nav-dock.scss';

type Props = {
    isOffline: boolean;
    currentRoute?: string;
    handleHome?: () => void;
    handleOpenOptions?: (e: React.MouseEvent<HTMLElement>) => void;
    handleOpenSearch?: () => void;
    handleOpenLibrary?: () => void;
}

export const NavDock = ({ isOffline, currentRoute, handleHome, handleOpenOptions, handleOpenSearch, handleOpenLibrary }: Props) => {

    const libraryRoutes = ["/my-playlists", "/my-library", "/saved-playlists"]
    const optionsRoutes = ["/my-user"]
    const searchRoutes = ["/search-open", "/search"]
    const allRoutes = [...libraryRoutes, ...optionsRoutes, ...searchRoutes]

    return (
        <div className="nav-dock">
            <div className="nav-dock__content">
                <button onClick={handleHome} className={classNames({ 'active': !allRoutes.includes(currentRoute || '') })}>
                    <i className="fa-solid fa-house"></i>
                    <span className='nav-dock__content__text'>Inicio</span>
                </button>
                <button onClick={handleOpenSearch} className={classNames({ 'active': searchRoutes.includes(currentRoute || '') })} disabled={isOffline}>
                    <i className="fa-solid fa-magnifying-glass"></i>
                    <span className='nav-dock__content__text'>Buscar</span>
                </button>
                <button onClick={handleOpenLibrary} className={classNames({ 'active': libraryRoutes.includes(currentRoute || '') })} disabled={isOffline} >
                    <i className="fa-solid fa-lines-leaning"></i>
                    <span className='nav-dock__content__text'>Biblioteca</span>
                </button>
                <button onClick={(e) => handleOpenOptions?.(e)} className={classNames({ 'active': optionsRoutes.includes(currentRoute || '') })}>
                    <i className="fa-solid fa-gear"></i>
                    <span className='nav-dock__content__text'>Opciones</span>
                </button>
            </div>
        </div>
    );
}